import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';

interface LottieBlockProps {
  animationData: object;
  className?: string;
  loop?: boolean;
}

const LottieBlock: React.FC<LottieBlockProps> = ({
  animationData,
  className = '',
  loop = true,
}) => {
  const [reduceMotion, setReduceMotion] = useState(false);

  useEffect(() => {
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReduceMotion(media.matches);
    const onChange = () => setReduceMotion(media.matches);
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, []);

  if (reduceMotion) {
    return <div className={className} aria-hidden="true" />;
  }

  return (
    <div className={className} aria-hidden="true">
      <Lottie animationData={animationData} loop={loop} />
    </div>
  );
};

export default LottieBlock;
